import { navItems } from "@/config/navigation";
import type { Page } from "@/types";
import { SidebarTrigger } from "@/components/layout/Sidebar/sidebar";

export function Topbar({ page }: { page: Page }) {
  const current = navItems.find((item) => item.id === page);
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/82 backdrop-blur">
      <div className="mx-auto flex h-16 min-w-0 max-w-[1540px] items-center justify-between gap-4 px-5 lg:px-7">
        <div className="flex min-w-0 items-center gap-3">
          <SidebarTrigger className="shrink-0" aria-label="Переключить меню" />
          <div className="min-w-0">
            <div className="truncate text-xs text-muted-foreground">Panel Jarvis / {current?.label}</div>
            <h1 className="truncate text-xl font-semibold tracking-normal">{current?.label}</h1>
          </div>
        </div>
      </div>
    </header>
  );
}
